import type { TranslationData } from '@/services/translateService.types'
import { getTranslateService } from '@/core/container/ioc'
import { isSupportedLocale } from '@/services/translateService.types'

export const registerTranslations = (i18n: TranslationData | TranslationData[]) => {
  const translateService = getTranslateService()

  const translations = Array.isArray(i18n) ? i18n : [i18n]

  translations.forEach((translation) => {
    for (const locale in translation) {
      if (isSupportedLocale(locale)) {
        const localeData = translation[locale]
        translateService.addLocaleMessages(localeData, locale)
      }
    }
  })
}
